<div class="dropdown-wrapper" #wrapper>
  <ng-content select="[trigger]"></ng-content>
  @if (open()) {
    <div #panel class="dropdown-panel" [class.dropdown-panel--end]="align() === 'end'" [class.dropdown-panel--up]="dropUp()">
      <ng-content></ng-content>
    </div>
  }
</div>
